import { render, staticRenderFns } from "./NotebookForBodyguards.vue?vue&type=template&id=afd7e4ec"
import script from "./NotebookForBodyguards.vue?vue&type=script&lang=js"
export * from "./NotebookForBodyguards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports